
















import { defineComponent, reactive } from '@vue/composition-api';
import { User } from '../../model/user';
import { usePageBase, useComponentBase } from '../../base';
import { AppListItem } from './app-list-item';
import { getStore } from '../../store';
import { useRouter } from '../../router';

const componentName = 'AppsList';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const pageBase = usePageBase();
        const componentBase = useComponentBase();

        const state = reactive({
            apps: [],
            loaded: false
        });

        const onCreated = () => {
            componentBase.setLoading(true);

            pageBase.setNavigation((nav) => {
                nav.push({ title: 'Apps' });
            });

            
            state.apps = store.state.apps;
            state.loaded = true;
            componentBase.setLoading(false);
        }

        const onItemClick = (appId: string) => {
            router.push({ name: 'app-versions', params: { appId: appId }});
        }

        onCreated();

        return {
            state,
            onItemClick
        }
    },

    components: { AppListItem }
})

